"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Score = exports.Headline = exports.Wrapper = void 0;
var react_1 = require("@emotion/react");
var styled_1 = __importDefault(require("@emotion/styled"));
var constants_1 = require("../constants");
var getScoreTextColor = function (type, theme) {
    var textColor = '';
    if (type === constants_1.RangeType.Normal) {
        textColor = theme.colors.gray50;
    }
    if (type === constants_1.RangeType.Minus) {
        textColor = theme.colors.red70;
    }
    if (type === constants_1.RangeType.Plus) {
        textColor = theme.colors.blue70;
    }
    return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), textColor);
};
exports.Wrapper = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    align-items: center;\n    justify-content: center;\n    background-color: ", ";\n    border: 0.1rem solid ", ";\n    border-radius: 2rem;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    align-items: center;\n    justify-content: center;\n    background-color: ", ";\n    border: 0.1rem solid ", ";\n    border-radius: 2rem;\n  "])), theme.colors.white, theme.colors.gray20);
});
exports.Headline = styled_1.default.h4(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return (0, react_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n\n    color: ", ";\n  "], ["\n    ", ";\n\n    color: ", ";\n  "])), theme.fonts.bold24, theme.colors.gray80);
});
exports.Score = styled_1.default.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, type = _a.type;
    return (0, react_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    ", "\n  "], ["\n    ", ";\n    ", "\n  "])), theme.fonts.bold46, getScoreTextColor(type, theme));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
